// File: src/components/ProductCard.tsx
import React from 'react';
import {Box, Button, Card, CardActions, CardContent, Chip, Typography} from '@mui/material';
import {Edit as EditIcon} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import {Product} from '../../types';

interface ProductCardProps {
    product: Product;
    onEdit: (product: Product) => void;
    // УДАЛЕНО: Пропс onViewResearch больше не нужен
}

const ProductCard: React.FC<ProductCardProps> = ({product, onEdit}) => {
    const {t} = useTranslation();

    return (
        <Card sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <CardContent sx={{p: 2.5, flexGrow: 1, display: 'flex', flexDirection: 'column'}}>

                {/* Image Gallery */}
                {product.images && product.images.length > 0 && (
                    <Box sx={{mb: 2, minHeight: '80px'}}>
                        <Box sx={{display: 'flex', gap: 1, overflowX: 'auto', pb: 1}}>
                            {product.images.slice(0, 4).map((imageUrl, index) => (
                                <Box
                                    key={index}
                                    component="img"
                                    src={imageUrl}
                                    alt={t('products.card.image_alt', { name: product.name, number: index + 1 })}
                                    sx={{
                                        width: 70,
                                        height: 70,
                                        objectFit: 'cover',
                                        borderRadius: 1.5,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        cursor: 'pointer',
                                        flexShrink: 0,
                                        '&:hover': {transform: 'scale(1.05)'}
                                    }}
                                    onClick={() => window.open(imageUrl, '_blank')}
                                />
                            ))}
                            {product.images.length > 4 &&
                                <Box sx={{
                                    width: 70,
                                    height: 70,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: 'action.hover',
                                    borderRadius: 1.5,
                                    color: 'primary.main',
                                    fontWeight: 600
                                }}>
                                    {t('products.card.more_images', { count: product.images.length - 4 })}
                                </Box>
                            }
                        </Box>
                    </Box>
                )}

                {/* Product Info */}
                <Typography variant="h6" sx={{mb: 1}}>{product.name}</Typography>

                {product.brand &&
                    <Chip
                        label={product.brand}
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{mb: 1.5, alignSelf: 'flex-start'}}
                    />
                }

                <Typography variant="body2" color="text.secondary" paragraph sx={{flexGrow: 1, overflow: 'hidden'}}>
                    {product.description || t('products.card.no_description')}
                </Typography>

                {/* Creation Date */}
                <Typography variant="caption" color="text.secondary" sx={{mt: 'auto', pt: 1}}>
                    {t('products.card.created_date', {
                        date: new Date(product.created_at).toLocaleDateString()
                    })}
                </Typography>
            </CardContent>

            <CardActions sx={{justifyContent: 'flex-end', p: 2, pt: 0}}>
                <Button size="small" startIcon={<EditIcon/>} onClick={() => onEdit(product)}>
                    {t('products.card.edit')}
                </Button>
            </CardActions>
        </Card>
    );
};

export default ProductCard;
